import { required, minLength, helpers } from '@vuelidate/validators';

/** Exported for tests; keep in sync with API (`UNICODE_LABEL_TITLE`). */
export const LABEL_TITLE_FORMAT_REGEX = /^[\p{L}\p{N}][\p{L}\p{N}\s_-]*$/u;

const labelTitlePattern = helpers.regex(LABEL_TITLE_FORMAT_REGEX);

export const getLabelTitleErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.title.$error) {
    errorMessage = '';
  } else if (!validation.title.required) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.REQUIRED_ERROR';
  } else if (!validation.title.minLength) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.MINIMUM_LENGTH_ERROR';
  } else if (!validation.title.labelTitlePattern) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.VALID_ERROR';
  }
  return errorMessage;
};

export default {
  title: {
    required,
    minLength: minLength(2),
    labelTitlePattern,
  },
  description: {},
  emoji: {},
  color: {
    required,
  },
  showOnSidebar: {},
};
